import React, {useState, useEffect, useRef} from 'react';
import './dropdown.css';

const Dropdown = ({
    label,
    items,
    onSelect,
    initialValue,
    placeholder,
    showLabel = true,
    width = 269
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(initialValue);
    const dropdownRef = useRef(null);

    const handleItemClick = (item) => {
        setSelectedValue(item.name);
        onSelect(item);
        setIsDropdownOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelectedValue(initialValue || null);
    }, [initialValue]);

    return (
        <div className="dropdown-container" ref={dropdownRef}>
            {showLabel && (
                <label
                    htmlFor="dropdown-button"
                    className="form-label mb-1 ms-3 dropdown-label"
                >
                    {label}
                </label>
            )}
            <div className="dropdown">
                <button
                    id="dropdown-button"
                    className="btn btn-light dropdown-toggle custom-dropdown d-flex flex-row justify-content-between align-items-center"
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    aria-expanded={isDropdownOpen}
                    style={{width: `${width}px`}}
                >
                    <span className="dropdown-span">
                        {selectedValue || placeholder}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
                        <path
                            d="M7.54236 9.08938C7.14647 9.08938 6.75052 8.93837 6.4484 8.63626L0.45311 2.64096C-0.151037 2.03681 -0.151037 1.05726 0.45311 0.453101C1.05723 -0.151034 2.03682 -0.151034 2.64095 0.453101L7.54236 5.35457L12.4438 0.453101C13.0479 -0.151034 14.0275 -0.151034 14.6316 0.453101C15.2358 1.05726 15.2358 2.03681 14.6316 2.64096L8.63633 8.63626C8.33423 8.93837 7.93825 9.08938 7.54236 9.08938Z"
                            fill="#9DACBD"/>
                    </svg>
                </button>
                {isDropdownOpen && (
                    <ul
                        className="dropdown-menu custom-dropdown-menu show py-0"
                    >
                        {items.map((item) => (
                            <li key={item.id}>
                                <span
                                    className="dropdown-item custom-dropdown-item py-2"
                                    onClick={() => handleItemClick(item)}
                                    title={item.name}
                                >
                                    {item.name}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default Dropdown;
